import type { Chord } from 'svguitar';

export const DChords: Record<string, Chord> = {
  D: {
    fingers: [
      [1, 2, '1'],
      [2, 3, '3'],
      [3, 2, '2'],
      [4, 0],
      [5, 'x'],
      [6, 'x'],
    ],
    barres: [],
    title: 'D',
    position: 0,
  },
  D9: {
    fingers: [
      [1, 0],
      [2, 3, '3'],
      [3, 2, '1'],
      [4, 0],
      [5, 'x'],
      [6, 'x'],
    ],
    barres: [],
    title: 'D9',
    position: 0,
  },
  'D9/F#': {
    fingers: [
      [1, 0],
      [2, 3, '3'],
      [3, 2, '2'],
      [4, 0],
      [5, 'x'],
      [6, 2, { text: '1', color: 'blue', className: 'blue' }],
    ],
    barres: [],
    title: 'D9/F#',
    position: 0,
  },
  D4: {
    fingers: [
      [1, 3, '4'],
      [2, 3, '3'],
      [3, 2, { text: '1', color: 'blue', className: 'blue' }],
      [4, 'x'],
      [5, 'x'],
      [6, 'x'],
    ],
    barres: [],
    title: 'D4',
    position: 0,
  },
  Dm: {
    fingers: [
      [1, 1, '1'],
      [2, 3, '3'],
      [3, 2, { text: '1', color: 'blue', className: 'blue' }],
      [4, 'x'],
      [5, 'x'],
      [6, 'x'],
    ],
    barres: [],
    title: 'Dm',
    position: 0,
  },
  'D/G': {
    fingers: [
      [1, 2, '1'],
      [2, 3, '3'],
      [5, 'x'],
      [6, 3, { text: '2', color: 'blue', className: 'blue' }],
    ],
    barres: [],
    title: 'D/G',
    position: 0,
  },
  'D/C': {
    fingers: [
      [1, 2, '1'],
      [2, 3, '3'],
      [4, 'x'],
      [5, 3, { text: '2', color: 'blue', className: 'blue' }],
      [6, 'x'],
    ],
    barres: [],
    title: 'D/C',
    position: 0,
  },
};
